var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1v44h12v14.5c0 1.93 1.57 3.5 3.5 3.5.98 0 1.864-.407 2.5-1.058.636.651 1.52 1.058 2.5 1.058 1.93 0 3.5-1.57 3.5-3.5v-14.5h38v-44zm26 40c0 1.103-.897 2-2 2v-9h-2v25.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-18.5h-2v18.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-25.5h-2v9c-1.103 0-2-.897-2-2v-6c0-4.411 3.589-8 8-8s8 3.589 8 8zm-13-21c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm47 23h-32.556c.344-.591.556-1.268.556-2v-5.434l4.277-2.566h25.723v-2h-2v-18h-6v18h-2v-10h-6v10h-2v-16h-6v16h-2.277l-3.875 2.325c-.576-3.392-2.855-6.21-5.933-7.525 1.86-1.26 3.085-3.39 3.085-5.8 0-3.859-3.14-7-7-7s-7 3.141-7 7c0 2.41 1.225 4.54 3.085 5.8-3.574 1.526-6.085 5.075-6.085 9.2v6c0 .732.212 1.409.556 2h-6.556v-32h58zm-24-12v-14h2v14zm8 0v-8h2v8zm8 0v-16h2v16zm8-22h-58v-6h58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5 5h2v2h-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9 5h2v2h-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13 5h2v2h-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m36 48.586-2 2v-2.586h-2v10h2v-2.586l2 2v.586h2v-1.414l-3.586-3.586 3.586-3.586v-1.414h-2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m43.5 48h-3.5v10h2v-3h1.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zm0 5h-1.5v-3h1.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48 50h2v6h-2v2h6v-2h-2v-6h2v-2h-6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m57 35h2v2h-2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m45 35h10v2h-10z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m57 39h2v2h-2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m45 39h10v2h-10z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m5 39h2v2h-2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m5 35h2v2h-2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m5 31h2v2h-2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi2);
export default __webpack_public_path__ + "static/media/kpi2.078c3135a35b09cb21aaf45601f89014.svg";
export { ForwardRef as ReactComponent };